import { createContext } from 'react';

export const RegPatientContext = createContext(null);